import { useQuery } from '@tanstack/react-query';

import BorrowerService from '../../../../../services/BorrowerService';
import SearchService from '../../../../../services/SearchService';

export default function useInitialSearch({ type, name, lenderId }) {
  const isBorrower = type.includes('orrower');

  const { data: borrowers, isFetching: areBorrowersFetching } = useQuery({
    queryKey: ['borrower', name, lenderId],
    queryFn: () => BorrowerService.searchBorrowers({ query: name, lenderId }),
    enabled: isBorrower && !!name,
  });

  const { data: vendors, isFetching: areVendorsFetching } = useQuery({
    queryKey: ['vendor', name, lenderId],
    queryFn: () =>
      SearchService.searchVendors({ query: name, type: ['Insurance'] }),
    enabled: !isBorrower && !!name,
  });

  const isFetching = areBorrowersFetching || areVendorsFetching;

  return {
    isFetching,
    borrower: borrowers?.[0],
    vendor: vendors?.[0],
    isBorrower,
  };
}
